import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { BuscarCircularPipe } from '../pipes/buscar-circular.pipe';
import { ExpandirImagenComponent } from './expandir-imagen/expandir-imagen.component';
import { ApadaviPipe } from '../pipes/apadavi.pipe';
import { QRReadComponent } from './qrread/qrread.component';
import { GeneradorQRComponent } from './generador-qr/generador-qr.component';
// import { QRCodeModule } from 'angular2-qrcode';
import { FormContactoComponent } from './form-contacto/form-contacto.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { TablaComponent } from './tabla/tabla.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { TablaUserFamiliaComponent } from './tabla-user-familia/tabla-user-familia.component';
import { TablaUsuariosComponent } from './tabla-usuarios/tabla-usuarios.component';
import { TablaFamiliaUserComponent } from './tabla-familia-user/tabla-familia-user.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { TablaRolesComponent } from './tabla-roles/tabla-roles.component';
import { ConfigGaleriaActividadComponent } from './config-galeria-actividad/config-galeria-actividad.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SeleccionarFuenteCodigoRegistroComponent } from './seleccionar-fuente-codigo-registro/seleccionar-fuente-codigo-registro.component';
import { CheckboxMultinivelComponent } from './checkbox-multinivel/checkbox-multinivel.component';
import { GrupoCheckboxMultiNivelComponent } from './grupo-checkbox-multi-nivel/grupo-checkbox-multi-nivel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FiltrosConsultasComponent } from './filtros-consultas/filtros-consultas.component';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { FiltroFechaPipe } from '../pipes/filtro-fecha.pipe';
import { DialogMailRecuperarPassComponent } from './dialog-mail-recuperar-pass/dialog-mail-recuperar-pass.component';
import { SelectConFotoComponent } from './select-con-foto/select-con-foto.component';
import { ZoomComponent } from './zoom/zoom.component';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './header/menu/menu.component';
import { PhonePipe } from './../pipes/phone.pipe';
import { IconosComponent } from './iconos/iconos.component';
import { InicialesPipe } from '../pipes/iniciales.pipe';
import { ListadoTarjetasComponent } from './listado-tarjetas/listado-tarjetas.component';
import { InfoAnticiposComponent } from './info-anticipos/info-anticipos.component';
import { SelectorFechaComponent } from './selector-fecha/selector-fecha.component';
import { PopoverComponent } from './popover/popover.component';
import { OpcionesExportarComponent } from './opciones-exportar/opciones-exportar.component';
import { PopoverMostrarLinkComponent } from './popover-mostrar-link/popover-mostrar-link.component';
import { TablaLogEventosComponent } from './tabla-log-eventos/tabla-log-eventos.component';
import { TablaLogActividadUsuarioComponent } from './tabla-log-actividad-usuario/tabla-log-actividad-usuario.component';
import { ReemplazarPipe } from '../pipes/reemplazar.pipe';
import { FiltroSubArreglosPipe } from '../pipes/filtro-sub-arreglos.pipe';
import { StepperComponent } from './stepper/stepper.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { GraficoActividadUsuariosComponent } from './grafico-actividad-usuarios/grafico-actividad-usuarios.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ExamplePdfViewerComponent } from '../example-pdf-viewer/example-pdf-viewer.component';
import { TituloSeccionComponent } from './titulo-seccion/titulo-seccion.component';
import { DescripcionFuncionPagosComponent } from './descripcion-funcion-pagos/descripcion-funcion-pagos.component';
import { MatTabsModule } from '@angular/material/tabs';
import { DocumentosPendientesComponent } from '../paginas/pagos-consultas/tablas/documentos-pendientes/documentos-pendientes.component';
import { ComprobantesFiscalesComponent } from '../paginas/pagos-consultas/tablas/comprobantes-fiscales/comprobantes-fiscales.component';
import { MensualidadComponent } from '../paginas/pagos-consultas/tablas/mensualidad/mensualidad.component';
import { CuotaInicialComponent } from '../paginas/pagos-consultas/tablas/cuota-inicial/cuota-inicial.component';
import { LibrosUtilesServiciosComponent } from '../paginas/pagos-consultas/tablas/libros-utiles-servicios/libros-utiles-servicios.component';
import { AnticiposComponent } from '../paginas/pagos-consultas/tablas/anticipos/anticipos.component';
import { EstadosCuentaComponent } from '../paginas/pagos-consultas/tablas/estados-cuenta/estados-cuenta.component';
import { ResumidoPipe } from '../paginas/pagos-consultas/tablas/estados-cuenta/resumido.pipe';
import { CompraUtilesComponent } from '../paginas/pagos-consultas/tablas/compra-utiles/compra-utiles.component';
import { FiltroTextoPipe } from '../paginas/pagos-consultas/tablas/libros-utiles-servicios/filtro-texto.pipe';
import { FiltroTipoPipe } from '../paginas/pagos-consultas/tablas/libros-utiles-servicios/filtro-tipo.pipe';
import { ListaEditableComponent } from './lista-editable/lista-editable.component';
import { FiltrarAsignaturasIndicadoresPipe } from '../pipes/filtrar-asignaturas-indicadores.pipe';
import { FiltrarIndicadoresPipe } from '../pipes/filtrar-indicadores.pipe';
import { RecursiveCheckBoxComponent } from './recursive-check-box/recursive-check-box.component';
import { FloorPipe } from '../pipes/floor.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    BuscarCircularPipe,
    ExpandirImagenComponent,
    ApadaviPipe,
    QRReadComponent,
    GeneradorQRComponent,
    FormContactoComponent,
    TablaComponent,
    TablaUserFamiliaComponent,
    TablaUsuariosComponent,
    TablaFamiliaUserComponent,
    PdfViewerComponent,
    TablaRolesComponent,
    ConfigGaleriaActividadComponent,
    SeleccionarFuenteCodigoRegistroComponent,
    CheckboxMultinivelComponent,
    GrupoCheckboxMultiNivelComponent,
    FiltrosConsultasComponent,
    SeleccionarFuenteCodigoRegistroComponent,
    CheckboxMultinivelComponent,
    GrupoCheckboxMultiNivelComponent,
    FiltroPipe,
    FiltroFechaPipe,
    DialogMailRecuperarPassComponent,
    SelectConFotoComponent,
    ZoomComponent,
    MenuComponent,
    PhonePipe,
    IconosComponent,
    InicialesPipe,
    ListadoTarjetasComponent,
    InfoAnticiposComponent,
    SelectorFechaComponent,
    PopoverComponent,
    OpcionesExportarComponent,
    PopoverMostrarLinkComponent,
    TablaLogEventosComponent,
    TablaLogActividadUsuarioComponent,
    ReemplazarPipe,
    FiltroSubArreglosPipe,
    StepperComponent,
    GraficoActividadUsuariosComponent,
    ExamplePdfViewerComponent,
    TituloSeccionComponent,
    DescripcionFuncionPagosComponent,
    DocumentosPendientesComponent, ComprobantesFiscalesComponent,
    MensualidadComponent, CuotaInicialComponent, LibrosUtilesServiciosComponent, AnticiposComponent,
    EstadosCuentaComponent, ResumidoPipe, CompraUtilesComponent, FiltroTextoPipe, FiltroTipoPipe,
    ListaEditableComponent,
    FiltrarAsignaturasIndicadoresPipe, FiltrarIndicadoresPipe, RecursiveCheckBoxComponent, 
    FloorPipe, 
  ],

  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    // QRCodeModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatSortModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRippleModule,
    NgxSkeletonLoaderModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatStepperModule,
    MatIconModule,
    NgxChartsModule,
    NgxMatSelectSearchModule,
    MatSelectModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    MatCheckboxModule,
    MatExpansionModule,
  ],
  providers: [],
  exports: [
    HeaderComponent,
    BuscarCircularPipe,
    ExpandirImagenComponent,
    ApadaviPipe,
    QRReadComponent,
    GeneradorQRComponent,
    FormContactoComponent,
    TablaComponent,
    TablaUserFamiliaComponent,
    TablaUsuariosComponent,
    TablaFamiliaUserComponent,
    PdfViewerComponent,
    TablaRolesComponent,
    NgxSkeletonLoaderModule,
    ConfigGaleriaActividadComponent,
    SeleccionarFuenteCodigoRegistroComponent,
    CheckboxMultinivelComponent,
    GrupoCheckboxMultiNivelComponent,
    FiltrosConsultasComponent,
    CheckboxMultinivelComponent,
    GrupoCheckboxMultiNivelComponent,
    FiltroPipe,
    ExamplePdfViewerComponent,
    FiltroFechaPipe,
    DialogMailRecuperarPassComponent,
    SelectConFotoComponent,
    ZoomComponent,
    MenuComponent,
    PhonePipe,
    IconosComponent,
    InicialesPipe,
    ListadoTarjetasComponent,
    InfoAnticiposComponent,
    SelectorFechaComponent,
    PopoverComponent,
    OpcionesExportarComponent,
    PopoverMostrarLinkComponent,
    TablaLogEventosComponent,
    TablaLogActividadUsuarioComponent,
    MatTableModule,
    MatPaginatorModule,
    ReemplazarPipe,
    FiltroSubArreglosPipe,
    StepperComponent,
    GraficoActividadUsuariosComponent,
    TituloSeccionComponent,
    DescripcionFuncionPagosComponent,
    DocumentosPendientesComponent, ComprobantesFiscalesComponent,
    MensualidadComponent, CuotaInicialComponent, LibrosUtilesServiciosComponent, AnticiposComponent,
    EstadosCuentaComponent, ResumidoPipe, CompraUtilesComponent, FiltroTextoPipe, FiltroTipoPipe,
    ListaEditableComponent,
    
    FiltrarAsignaturasIndicadoresPipe, FiltrarIndicadoresPipe, RecursiveCheckBoxComponent,
    FloorPipe, 
  ],
})
export class ComponentesModule {}
